import { Observable, throwError as observableThrowError } from 'rxjs';

export class GhGlobal {
  static throwMissingArgsError(): Observable<any> {
    return observableThrowError(Error('Missing arguments'));
  }

  static customError(err: any): string {
    if (err.message && (err.message.includes('Unknown Error') || err.message.includes('Gateway Timeout'))) {
      if (navigator?.onLine) {
        return 'Something went wrong. Service might be unavailable. Please try again later.';
      } else {
        return 'Something went wrong. Please make sure you have an internet connection and try again.';
      }
    }
    if (err.error) {
      return err.error.message || err.error.errorMessage || err.message;
    }
    return err.message;
  }

  static compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  static wrapWithBold(terms: string, searchTerms: any[]): string {
    let result = terms;

    for (let word of searchTerms) {
      word = word.replace(/(\(|\))/g, '\\$1');
      result = result.replace(new RegExp('(' + word + '[^\\s]*)', 'i'), '<b>$1</b>').replace(/.*(<b .*\/b>).*/g, '$1');
    }
    return result;
  }

  static injectStyle(color: string, doc: Document) {
    const styleEl = doc.getElementById('bgr-color');
    if (!color) {
      styleEl.removeAttribute('style');
      styleEl.classList.remove('light-theme');
      return;
    }
    styleEl.classList.add('light-theme');
    styleEl.style.backgroundColor = color;
    // if we need to use transparent
    // const rgbArr = color.substr(1).match(/(..?)/g);
    // const rgba = rgbArr.map((el) => parseInt(el, 16)).toString() + ',0.50'; // 25% transparency
    // styleEl.style.backgroundColor = `rgba(${rgba})`;
  }
}
